import axios from 'axios';

import {API_URL} from './constants';

const generateIntegration = async ({assignment, userInfo, options}): Promise<{script: string, url: string}> => {
    const result = await axios.post(
        `${API_URL}/live-help/generate-integration`,
        {assignment, userInfo, options}
    );
    return result.data as {script: string, url: string};
};

const downloadDocumentation = async (): Promise<string> => {
    const result = await axios.get(`${API_URL}/live-help/download-documentation`);
    return result.data;
};

export const livehelpApi = {
    generateIntegration,
    downloadDocumentation
};